import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CancelToken, isCancel } from 'axios';
import AssetService from '../../Services/AssetService';
import DeleteCustomerOTAModalDisplay from './DeleteCustomerOTAModalDisplay';

export default class DeleteCustomerOTAModal extends Component {
  static propTypes = {
    asset: PropTypes.shape({
      _id: PropTypes.string,
      gtemplateID: PropTypes.string,
    }),
    isOpen: PropTypes.bool,
    handleCustomerOTADeleted: PropTypes.func,
    toggleModal: PropTypes.func,
    customerOTAselected: PropTypes.shape({
      filename: PropTypes.string, // just the filename
      displayName: PropTypes.string, // the filename but maybe truncated for display
      name: PropTypes.string, // blob storage name
      type: PropTypes.string, // just the prefix like "hfx_flash"
      typeName: PropTypes.string, // name found from looking up in our types table
      properties: PropTypes.object, // from blob storage
      createdOn: PropTypes.string, // "x ago" string from properties.createdOn time
    }),
  };

  state = { error: '', deleteRequestPending: false };
  assetService = new AssetService();
  source = CancelToken.source();

  componentWillUnmount() {
    this.source.cancel();
  }

  handleCustomerOTADelete = async () => {
    this.setState({ deleteRequestPending: true });
    try {
      const {
        asset: { _id: assetID },
        customerOTAselected,
      } = this.props;
      await this.assetService.deleteAssetCustomerOTA(
        assetID,
        {
          filename: customerOTAselected.filename,
          type: customerOTAselected.type,
        },
        this.source.token
      );

      this.setState({ deleteRequestPending: false }, () => {
        this.props.handleCustomerOTADeleted(customerOTAselected);
        this.props.toggleModal();
      });
    } catch (err) {
      if (isCancel(err)) return;
      const error = err.response?.data?.message ?? err.message;
      this.setState({ error, deleteRequestPending: false });
    }
  };
  render() {
    return (
      <DeleteCustomerOTAModalDisplay
        {...this.props}
        {...this.state}
        handleCustomerOTADelete={this.handleCustomerOTADelete}
      />
    );
  }
}
